/** Nome exibível da tarefa: "#123 Título". Idempotente se o título já tem o mesmo id. */
export function formatTaskDisplayName(id, title) {
  const cid = Number(id);
  const name = String(title || "").trim();
  if (!Number.isFinite(cid) || cid <= 0) return name || "";
  const prefix = `#${cid}`;
  if (!name) return prefix;
  if (name === prefix || name.startsWith(`${prefix} `)) return name;
  return `${prefix} ${name}`;
}

function stripLegacyTaskChannelPrefix(name) {
  return String(name || "")
    .replace(/^Tarefa\s*[—–-]\s*/i, "")
    .trim();
}

/** "#123 Título" para canal de tarefa; null quando o espaço não é discussão de tarefa. */
export function formatTaskSpaceName(space) {
  if (!space) return null;
  const fromSlug = String(space.slug || "").match(/^tarefa-(\d+)$/i);
  const cid = space.cardId != null ? Number(space.cardId) : fromSlug ? Number(fromSlug[1]) : NaN;
  if (!Number.isFinite(cid) || cid <= 0) return null;
  const stripped = stripLegacyTaskChannelPrefix(space.name);
  return formatTaskDisplayName(cid, stripped || "Tarefa");
}

/**
 * Termo da busca geral que é só o id da tarefa: 123, #123 ou tarefa-123.
 * Texto livre não entra nesse padrão.
 */
export function parseTaskIdSearchQuery(q) {
  const term = String(q || "").trim();
  if (!term) return null;
  let match = term.match(/^#(\d+)$/);
  if (!match) match = term.match(/^(\d+)$/);
  if (!match) match = term.match(/^tarefa[-\s]#?(\d+)$/i);
  if (!match) return null;
  const id = Number(match[1]);
  if (!Number.isInteger(id) || id <= 0) return null;
  return id;
}
